
<div class="m-b-20">
  <div class="flexie-auto-grid">
    <!-- Search -->
    <div>

      <div>
        <h3>Search</h3>
        <!-- <app-ui-search [searchables]="['Servicing Number','Policy Number','Insured Name']"></app-ui-search> -->
      </div>

    </div>
    <!-- Inbox Type Switcher: My/Subordinate/Team -->
    <div class="text-a-right">
      <h3>Inbox</h3>
      <nz-radio-group [(ngModel)]="radioValue" [nzButtonStyle]="'solid'" [nzSize]="'default'">
        <label nz-radio-button nzValue="myCases" (click)="loadCases('myCases')"><i nz-icon nzType="user" nzTheme="outline"></i> My Cases</label>
        <label nz-radio-button nzValue="subCases" (click)="loadCases('subCases')"><i nz-icon nzType="usergroup-add" nzTheme="outline"></i> Subordinate Cases</label>
        <label nz-radio-button nzValue="teamCases" (click)="loadCases('teamCases')"><i nz-icon nzType="team" nzTheme="outline"></i> Team Cases</label>
      </nz-radio-group>
    </div>
  </div>
</div>

<div class="inbox-grid-servicing">

  <!-- LHS: Tree Block -->
  <div class="inbox-tree-servicing">
    <nz-tree [nzData]="nodes" nzShowIcon="true" (nzClick)="treeClick($event)"></nz-tree>
  </div>

  <!-- RHS: Content -->
  <div class="inbox-content-servicing">

    <!-- Fake Load (DEMO ONLY -- REMOVE ME!!!) -->
    <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="isLoading" *ngFor="let i of [1,2,3,4,5,6,7,8]">
    </nz-skeleton>

    <!-- Cards -->
    <app-servicing-card *ngFor="let i of [1]" [data]="{status:'pending'}"></app-servicing-card>
    <app-servicing-card *ngFor="let i of [1,2,3,4]"></app-servicing-card>

  </div>

</div>

<!-- Pagination -->
<div class="pagination-inbox text-a-center">
  <nz-pagination [nzPageIndex]="1" [nzTotal]="300" nzShowSizeChanger [nzPageSize]="10"></nz-pagination>
</div>






